import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useDataContext } from "../hub/data-context-provider.js";
import { PlatformIcon } from "./platform-icons.js";
export function ScoutList({ workspaceId, selectedChannelId, onSelect }) {
    const ctx = useDataContext();
    const [scouts, setScouts] = useState(null);
    const [channels, setChannels] = useState([]);
    const [error, setError] = useState(null);
    useEffect(() => {
        let cancelled = false;
        setScouts(null);
        setChannels([]);
        setError(null);
        Promise.all([ctx.hub.listWorkspaceScouts(workspaceId), ctx.hub.listChannels(workspaceId)])
            .then(([s, c]) => {
            if (cancelled)
                return;
            setScouts(s);
            setChannels(c);
        })
            .catch((e) => {
            if (!cancelled)
                setError(e instanceof Error ? e.message : String(e));
        });
        return () => {
            cancelled = true;
        };
    }, [ctx.hub, workspaceId]);
    if (error)
        return _jsxs("div", { style: { color: "var(--error)" }, children: ["Hub error: ", error] });
    if (!scouts)
        return _jsx("div", { style: { color: "var(--text-muted)" }, children: "Loading scouts\u2026" });
    if (scouts.length === 0) {
        return (_jsx("div", { style: { color: "var(--text-muted)", fontSize: 12, padding: "4px 8px" }, children: "No Scouts leased." }));
    }
    return (_jsx("ul", { style: { listStyle: "none", padding: 0, margin: 0 }, children: scouts.map((s) => {
            const streamChannel = channels.find((c) => c.scout_instance_id === s.id) ?? null;
            const selected = streamChannel?.id === selectedChannelId;
            const label = s.display_name || s.id;
            // "online" = seen within the last 60 seconds per last_seen_at heartbeat.
            const isOnline = s.last_seen_at !== null &&
                Date.now() - new Date(s.last_seen_at).getTime() < 60_000;
            const subtitle = isOnline ? "online" : "offline";
            return (_jsx("li", { children: _jsxs("button", { type: "button", onClick: () => {
                        if (streamChannel)
                            onSelect(streamChannel, s);
                    }, disabled: !streamChannel, style: {
                        width: "100%",
                        textAlign: "left",
                        padding: "4px 8px 4px 22px",
                        background: selected
                            ? "color-mix(in oklab, var(--accent-soft) 60%, var(--paper-2))"
                            : "transparent",
                        border: "none",
                        borderLeft: `2px solid ${selected ? "var(--accent)" : "transparent"}`,
                        borderRadius: 0,
                        cursor: streamChannel ? "pointer" : "not-allowed",
                        fontFamily: "inherit",
                        fontSize: 13,
                        color: selected ? "var(--ink)" : "var(--ink-2)",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        minHeight: 24,
                        opacity: streamChannel ? 1 : 0.6,
                        transition: "background 80ms ease",
                    }, onMouseEnter: (e) => {
                        if (!selected && streamChannel)
                            e.currentTarget.style.background = "var(--paper-3)";
                    }, onMouseLeave: (e) => {
                        if (!selected)
                            e.currentTarget.style.background = "transparent";
                    }, title: streamChannel
                        ? undefined
                        : "No stream channel linked — lease or re-enroll this Scout.", children: [_jsx(PlatformIcon, { platform: s.platform, size: 14, title: s.platform, style: {
                                flexShrink: 0,
                                color: selected
                                    ? "var(--accent-ink)"
                                    : isOnline
                                        ? "var(--ink)"
                                        : "var(--ink-4)",
                                opacity: !selected && !isOnline ? 0.6 : 1,
                            } }), _jsx("span", { style: { flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }, children: label }), _jsx("span", { style: {
                                width: 6,
                                height: 6,
                                borderRadius: "50%",
                                backgroundColor: isOnline ? "var(--p4)" : "var(--ink-4)",
                                opacity: !isOnline ? 0.55 : 1,
                                flexShrink: 0,
                            }, "aria-label": subtitle })] }) }, s.id));
        }) }));
}
//# sourceMappingURL=ScoutList.js.map